'use client'

import { Image } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import useHowItWorksCardContent from './useHowItWorksCardContent'
import useHowItWorksClosingSubSectionContent from './useHowItWorksClosingSubSectionContent'
import HowItWorksClosingSubSection from './HowItWorksClosingSubSection'

type Props = { ukVersion?: boolean }

const HowItWorksSection = ({ ukVersion }: Props) => {
  const translate = useTranslate('dac7-2024.how_it_works')
  const cardsContent = useHowItWorksCardContent()
  const { ukVersionContent, nonUkVersionContent } = useHowItWorksClosingSubSectionContent()

  const renderClosingSubSection = () => {
    const subSectionContent = ukVersion ? ukVersionContent : nonUkVersionContent

    return (
      <>
        {subSectionContent.map((content, index) => (
          <HowItWorksClosingSubSection {...content} index={index} key={index} />
        ))}
      </>
    )
  }

  return (
    <section className="dac7__howitworks" data-testid="howitworks-section">
      <div className="dac7__howitworks-steps">
        <div className="dac7__howitworks-inner">
          <h1 className="dac7__howitworks-title">{translate('title')}</h1>
          <div className="dac7__howitworks-cards">
            {cardsContent.map((card, index) => (
              <div
                key={index}
                className="dac7__howitworks-card"
                data-testid={`howitworks-card-${index + 1}`}
              >
                <div className="dac7__howitworks-card-inner">
                  <div className="dac7__howitworks-card-image">
                    <Image
                      src={card.imageSrc}
                      srcset={card.imageSrcSet}
                      scaling={Image.Scaling.Cover}
                      loading="lazy"
                    />
                  </div>
                  <div className="dac7__howitworks-card-content">
                    <div className="dac7__howitworks-card-title">{translate(card.title)}</div>
                    <div
                      className="dac7__howitworks-card-description"
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{ __html: translate(card.description) }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {renderClosingSubSection()}
    </section>
  )
}

export default HowItWorksSection
